interface Props {
	className?: string;
	size?: number;
}

export const Lock: React.FC<Props> = ({ className, size }) => {
	return (
		<svg
			width={`${size ? `${size}` : '18'}`}
			height={`${size ? `${size}` : '18'}`}
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M14.625 5.625H12.375V3.9375C12.375 3.04239 12.0194 2.18395 11.3865 1.55101C10.7536 0.918079 9.89511 0.5625 9 0.5625C8.10489 0.5625 7.24645 0.918079 6.61351 1.55101C5.98058 2.18395 5.625 3.04239 5.625 3.9375V5.625H3.375C3.07663 5.625 2.79048 5.74353 2.5795 5.9545C2.36853 6.16548 2.25 6.45163 2.25 6.75V14.625C2.25 14.9234 2.36853 15.2095 2.5795 15.4205C2.79048 15.6315 3.07663 15.75 3.375 15.75H14.625C14.9234 15.75 15.2095 15.6315 15.4205 15.4205C15.6315 15.2095 15.75 14.9234 15.75 14.625V6.75C15.75 6.45163 15.6315 6.16548 15.4205 5.9545C15.2095 5.74353 14.9234 5.625 14.625 5.625ZM3.375 9H14.625V10.125H3.375V9ZM3.375 11.25H14.625V12.375H3.375V11.25ZM6.75 3.9375C6.75 3.34076 6.98705 2.76847 7.40901 2.34651C7.83097 1.92455 8.40326 1.6875 9 1.6875C9.59674 1.6875 10.169 1.92455 10.591 2.34651C11.0129 2.76847 11.25 3.34076 11.25 3.9375V5.625H6.75V3.9375ZM14.625 6.75V7.875H3.375V6.75H14.625ZM14.625 14.625H3.375V13.5H14.625V14.625Z"
				fill="currentColor"
			/>
		</svg>
	);
};
